import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import BdsTooltip from '../../../../../shared/components/v3/BdsTooltip/BdsTooltip';
import BdsIconButton from '../../../../../shared/components/v3/Buttons/BdsIconButton/BdsIconButton';
import { ADD_PERSON, TRASH_NE } from '../../../../../shared/constants/images';
import { IToAddMembersData } from '../../../../../shared/interfaces/collaborators';
import { TRANSLATION_COLLABORATORS } from '../../../../../shared/translations/collaborators';
import CollaboratorsAssignModal from '../CollaboratorsToAddModal/CollaboratorsAssignModal/CollaboratorsAssignModal';
import CollaboratorsDismissModal from '../CollaboratorsToAddModal/CollaboratorsDismissModal/CollaboratorsDissmisModal';

import './CollaboratorsToAddTableActions.scss';

interface ICollaboratorsToAddTableActionsProps {
  collaboratorData: IToAddMembersData;
  onChange: (member?: string[]) => Promise<void>;
}

const CollaboratorsToAddTableActions = ({ collaboratorData, onChange }: ICollaboratorsToAddTableActionsProps) => {
  const [addCollaboratorModal, setAddCollaboratorModal] = useState(false);
  const [deleteCollaboratorModal, setDeleteCollaboratorModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div className="last-icons">
        <BdsTooltip
          message={t(TRANSLATION_COLLABORATORS.table.tooltips.addCollaborator)}
          position="bottom-right"
          variant="standard"
        >
          <BdsIconButton
            icon={ADD_PERSON}
            action={() => setAddCollaboratorModal(true)}
            variant="transparent"
            size="sm"
            label="add"
          />
        </BdsTooltip>
        <BdsTooltip
          message={t(TRANSLATION_COLLABORATORS.table.tooltips.deletePending)}
          position="bottom-right"
          variant="standard"
        >
          <BdsIconButton
            icon={TRASH_NE}
            action={() => setDeleteCollaboratorModal(true)}
            variant="transparent"
            size="sm"
            label="delete"
          />
        </BdsTooltip>
      </div>
      <CollaboratorsAssignModal
        emails={[collaboratorData.email]}
        onFinally={onChange}
        openModal={addCollaboratorModal}
        setOpenModal={setAddCollaboratorModal}
      />
      <CollaboratorsDismissModal
        onFinally={onChange}
        emails={[collaboratorData.email]}
        openModal={deleteCollaboratorModal}
        setOpenModal={setDeleteCollaboratorModal}
      />
    </>
  );
};

export default CollaboratorsToAddTableActions;
